import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { AccountService } from 'src/app/services/account.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { SessionDataService } from 'src/app/services/session-data.service';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { environment } from 'src/environments/environment';
import { VerificationComponent } from '../verification/verification.component';
import { Location } from '@angular/common';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';
import { CustomerfeedbackmanagementService } from 'src/app/services/customerfeedbackmanagement.service';
declare var window: any;
@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent implements OnInit {
  @Input() label: any;
  @Input() sku: any;
  @Input() addon: any;
  @Input() isParentalControl: boolean;
  @Input() areanprosuccess:boolean;
  @Input() source: string = 'CONFIG';
  @Output() subscribeAddon: EventEmitter<any> = new EventEmitter();

  count: any;
  public isNavCollapsed: boolean = true;
  toggleDropdown: boolean = false;
  userLoggedIn: boolean = false;
  userData: any;
  language: any = '';
  isArabic: boolean;
  ENV: any;
  currentAccount: any;
  constructor(
    private AS: AccountService,
    private SKUDS: SkuDataService,
    private SS: SubjectService,
    private route: Router,
    private modalController: ModalController,
    private SDS: SessionDataService,
    private UTS: UtilitiesService,
    public TS: TranslateService,
    private GAS: GoogleAnalyticsService,
    private location: Location,
    private appInitService: ApplicationInitializationService,
    private CFM: CustomerfeedbackmanagementService,
  ) {
    if (localStorage.getItem('currentAccount')) {
      const currentAccount = JSON.parse(localStorage.getItem('currentAccount'));
      if (currentAccount) {
        this.currentAccount = currentAccount;
      }
    }
  }

  ngOnInit() {
    const locale = this.UTS.getLocaleLanguage().toLocaleLowerCase();
    if (locale == 'ar') {
      this.isArabic = true;
    } else {
      this.isArabic = false;
    }

    this.ENV = this.UTS.getENV();
    this.getUserInfo();
    this.getCart();
  }

  getCart() {
    this.count = 0;
    this.AS.getShoppingCart().subscribe(
      (r: any) => {
        if (r && r.items) {
          this.count = r?.numberOfItemsInCart ? r?.numberOfItemsInCart : 0;
        }
      },
      (e) => {
        if (e && e.error) {
          // this.UTS.error(e.error.message);
        }
      }
    );
  }

  getUserInfo() {
    this.language =
      localStorage.getItem('language') &&
      localStorage.getItem('language').toLocaleLowerCase();
    this.AS.UserInfo().subscribe(
      (r: any) => {
        if (r) {
          this.userData = r;
          this.CFM.checkcustomerFeedback(this.userData)
          this.userLoggedIn = true;
        }
      },
      () => {
        this.userLoggedIn = false;
        this.CFM.userNotLogin()
      }
    );
  }

  signIn() {
    document.location.href = document.location.origin;
  }

  changeLangAction() {
    const lang = localStorage.getItem('language');
    localStorage.setItem('curr_language', lang.toLocaleLowerCase() === 'ar'? 'English': 'Arabic');
    if (lang.toLocaleLowerCase() == 'en') {
      localStorage.setItem('language', 'ar');
      this.TS.setDefaultLang('ar');
      const url =
        window.location.href.split('?') && window.location.href.split('?')[0]
          ? window.location.href.split('?')[0] +
            '?skuId=' +
            this.sku.skuId +
            '&lang=ar'
          : window.location.href.split('?')[0] + '?lang=ar';

      window.location.href = url;
    }
    if (lang.toLocaleLowerCase() == 'ar') {
      localStorage.setItem('language', 'en');
      this.TS.setDefaultLang('en');
      const url =
        window.location.href.split('?') && window.location.href.split('?')[0]
          ? window.location.href.split('?')[0] +
            '?skuId=' +
            this.sku.skuId +
            '&lang=en'
          : window.location.href.split('?')[0] + '?lang=en';

      window.location.href = url;
    }
  }

  logOut() {
    this.AS.logOut().subscribe((res) => {
      this.signIn();
    });
  }

  trackOrder() {
    window.location.href = environment.BASE_URL + '/userOrdersTracking';
  }

  goToCart() {
    const OS = this.UTS.getMobileOperatingSystem();
    if (this.ENV == 'mobile' && OS == 'Android') {
      window.deals.goToCartScreen();
    } else if (this.ENV == 'mobile' && OS == 'iOS') {
      (window as any).webkit.messageHandlers.hybridInterface.postMessage(
        'cart'
      );
    }
  }

  openDetailPage(sku: any, i: number) {
    if (this.isParentalControl) {
      this.subscribeAddon.emit();
      return;
    }
    this.SKUDS.set(sku);
    this.SDS.setAddon(this.addon);
    if (i == 0) {
      this.subscribe(sku);
    } else {
      if (this.addon == 'elife' || this.addon == 'tv') {
        this.route.navigate(['/addon/detail/elife']);
      } else {
        this.route.navigate(['/addon/detail']);
      }
    }
  }

  private subscribe(sku: any) {
    const userInfo: any = this.AS.getUInfo();
    this.productClick_Roaming(sku);
    this.CFM.SetDataintransactionalSurvey(sku);
    if (userInfo && userInfo.mainServiceAccountNo) {
      this.SS.skuDetails.next(sku);
      this.openBottomSheet(VerificationComponent, {});
    } else {
      this.SS.skuDetails.next(sku);
      this.openBottomSheet(VerificationComponent, {});
    }
  }

  productClick_Roaming(sku) {
    if (localStorage.getItem('isRoaming') !== null) {
      let product = [
        {
          name: sku?.displayName,
          id: sku?.id ? sku.id : sku.skuId ? sku.skuId : '',
          price: sku?.listPrice,
          brand: sku?.brand,
          category: 'Roaming',
          user_env: this.UTS.getENV(),
          variant: 'Gray',
          quantity: sku?.quantity,
        },
      ];

      let modal_data = {
        event: 'addToCart',
        user_env: this.UTS.getENV(),
        ecommerce: {
          add: {
            actionField: { list: 'Search Results' },
            products: product,
          },
        },
      };
      this.GAS.productClick_RoamingType(modal_data);
    }
  }

  async openBottomSheet(component: any, data?: any) {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data },
      cssClass: 'verification-modal modal-fullscreen',
    });
    return await modal.present();
  }

  back() {
    const OS = this.UTS.getMobileOperatingSystem();
    if(this.ENV === 'mobile' && this.UTS.getNavigationSource() && this.UTS.getNavigationSource() === 'parentalControl'){
      if(OS === 'Android'){
        window.ParentalControl.goBackScreen(this.UTS.getNavigationSource());
      }else if(OS === 'iOS'){
        const messgeToPost = {
          method: 'goBackScreen',
          payload: this.UTS.getNavigationSource(),
        };
        (window as any).webkit.messageHandlers.hybridInterface.postMessage(
          JSON.stringify(messgeToPost)
        );
      }
    }
    else{
      if(this.isParentalControl){
        const CAT = localStorage.getItem('CAT')?localStorage.getItem('CAT'):this.appInitService.environmentConfig?.PARENTAL_CONTROL_ADDONS;
        this.route.navigateByUrl(`/parentalControlAddons?subCategory=${CAT}&lang=${
          this.UTS.getLocaleLanguage().toLocaleLowerCase()}`);
		  } else if(localStorage.getItem('isRoaming')!==null&&localStorage.getItem('isRoaming')=='true'){
          this.location.back();
        } else{
          this.location.back();
          // const CAT = localStorage.getItem('CAT')
          // ? localStorage.getItem('CAT')
          // : AppSettings.POSTPAID;
          // const subCategoryId = localStorage.getItem('subCategoryId');
          // const url =
          //   '/addons?subCategory=' +
          //   CAT +
          //   '&categoryDimension=' +
          //   subCategoryId +
          //   '&lang=' +
          //   this.UTS.getLocaleLanguage();
          // this.route.navigateByUrl(url);
        }
      }
    }
}